import { extendTheme, type ThemeConfig } from "@chakra-ui/react";

const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: true,
};

const theme = extendTheme({
  config,
  colors: {
    brand: {
      50: "#E6F3FF",
      100: "#CCE7FF",
      200: "#99CFFF",
      300: "#66B7FF",
      400: "#339FFF",
      500: "#3182CE",
      600: "#2A69AC",
      700: "#1E4A7A",
      800: "#1A365D",
      900: "#0F2941",
    },
    gray: {
      50: "#F7FAFC",
      100: "#EDF2F7",
      200: "#E2E8F0",
      300: "#CBD5E0",
      400: "#A0AEC0",
      500: "#718096",
      600: "#4A5568",
      700: "#2D3748",
      800: "#1A202C",
      900: "#171923",
    },
  },
  fonts: {
    heading: '"Inter", sans-serif',
    body: '"Inter", sans-serif',
  },
  styles: {
    global: (props: any) => ({
      body: {
        bg: props.colorMode === "dark" ? "gray.900" : "gray.50",
        color: props.colorMode === "dark" ? "white" : "gray.800",
      },
    }),
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "semibold",
        borderRadius: "lg",
      },
      variants: {
        solid: (props: any) => ({
          bg: "brand.500",
          color: "white",
          _hover: {
            bg: "brand.600",
            transform: "translateY(-2px)",
          },
          transition: "all 0.2s ease",
        }),
        outline: (props: any) => ({
          borderColor: "brand.500",
          color: "brand.500",
          _hover: {
            bg: props.colorMode === "dark" ? "brand.900" : "brand.50",
            transform: "translateY(-2px)",
          },
          transition: "all 0.2s ease",
        }),
      },
    },
  },
});

export default theme;
